import { useEffect } from "react";
import { twMerge } from "tailwind-merge";
import OutsideAlerter from "../../shared/helpers/outsideClick";
import { IStyles } from "../../types";

/**
 * Modal shell. Fixed to the viewport (it used to be `absolute w-screen
 * h-screen`, which sat at the top of a scrolled page and shifted the layout
 * when it opened), scrolls inside itself on long forms and locks the page
 * behind it while open.
 */
const Popup = ({
  setIsOpen,
  children,
  customStyle,
  className,
  contentClass,
}: {
  setIsOpen: Function;
  children: React.ReactNode;
  customStyle?: IStyles;
  className?: string;
  contentClass?: string;
}) => {
  useEffect(() => {
    const { body } = document;
    const previous = body.style.overflow;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = previous;
    };
  }, []);

  return (
    <div
      className={twMerge(
        "fixed inset-0 z-[1050] overflow-y-auto overscroll-contain bg-black/25 backdrop-blur-sm",
        className,
      )}
    >
      <OutsideAlerter setState={setIsOpen}>
        <div
          className={twMerge(
            "flex items-start justify-center my-10 mx-auto w-[min(100vw-32px,520px)] rounded bg-white",
            contentClass,
          )}
          style={customStyle}
        >
          {children}
        </div>
      </OutsideAlerter>
    </div>
  );
};

export default Popup;
